import common from '../constants/common';

export default (status) =>
  common.ccmStatus[status] ? common.ccmStatus[status].label : 'Invalid status';
